// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-breadcrumb{margin:-24px -25px 27px -25px}", ""]);
// Exports
module.exports = exports;
